import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { RadioButtons } from "@swivl-mono/ui";
import _ from "lodash";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const OpenOrClose = {
  Type: "openOrClose",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: OpenOrClose.Type,
      showTyping: false,
      delay: 0,
      open: true,
      goto: null
    };

    return node;
  },

  PlumbData: function (node: NodeInterface) {
    const title = node.open ? "Open" : "Close";

    return TabNodeLayoutData({
      node: node,
      label: "Open or Close",
      title: title,
      baseWidth: 160,
      tabs: [{ id: "onCompleteGoto", source: "goto", target: node.goto }]
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.buttonSelected = this.buttonSelected.bind(this);
    }

    buttonSelected(name) {
      const value = name == "open" ? true : false;
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "open", value);
      this.props.updateNode(node, this.props.node, true);
    }

    render() {
      var self = this;
      const options = [
        { id: "open", value: true, label: "Open" },
        { id: "close", value: false, label: "Close" }
      ];
      return (
        <div>
          <div className="panel openOrClose_panel" style={{ paddingBottom: "300px" }}>
            <InspectorNodeHeader title="Open Or Close Chat" />
            <div className="panelRow">
              <DelayComponent node={this.props.node} onChange={this.onChangeUpdateAndRedraw} hideEllipsisOption={true} />

              <RadioButtons options={options} name="open" value={this.props.node.open} onChange={this.onChangeUpdateAndRedraw} />
            </div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};

export default OpenOrClose;
